import { AccountColour } from "__generated__/graphql";
import { theme } from "common/theme/theme";

export const getAccountColour = (colour: AccountColour): string => {
  switch (colour) {
    case AccountColour.Col1:
      return theme.palette.accent.lightGreen.light;
    case AccountColour.Col2:
      return theme.palette.accent.yellow.light;
    case AccountColour.Col3:
      return theme.palette.accent.shadeBlue.light;
    case AccountColour.Col4:
      return theme.palette.accent.pink.light;
    case AccountColour.Col5:
      return theme.palette.accent.purple.light;
    case AccountColour.Col6:
      return theme.palette.accent.other.lightBlue;
    case AccountColour.Col7:
      return theme.palette.accent.other.lightAqua;
    case AccountColour.Col8:
      return theme.palette.accent.lightGreen.light;
    case AccountColour.Col9:
      return theme.palette.accent.teal.light;
    case AccountColour.Col10:
      return theme.palette.accent.darkOrange.light;
    case AccountColour.ColDefault:
      return theme.palette.accent.other.default;
  }
};
